import { SignupSuccess } from '../../components/signup/SignupSuccess';

const SignupSuccessPage = () => {
  return <SignupSuccess />;
};

export default SignupSuccessPage;
